var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GridVx',{ref:"bookingRoomTable",attrs:{"columns":_vm.columnDefs,"auto-select-first-row":false,"auto-size-cell":true,"context":_vm.context,"rows":_vm.rowsUpdate,"want-to-get-row-selected-event":true},on:{"rowClicked":_vm.onSelectionChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }